import { Pause, Play } from "lucide-react";

export function ChartPauseButton({
  paused,
  onToggle,
  inline,
}: {
  paused: boolean;
  onToggle: () => void;
  /** Match range pill buttons when nested in a control group. */
  inline?: boolean;
}) {
  return (
    <button
      type="button"
      onClick={onToggle}
      aria-pressed={paused}
      aria-label={paused ? "Resume chart updates" : "Pause chart updates"}
      title={paused ? "Resume updates" : "Pause updates (keeps zoom)"}
      className={[
        "inline-flex items-center justify-center transition-colors",
        inline
          ? [
              "rounded px-2 py-1",
              paused
                ? "bg-accent text-white"
                : "text-text-secondary hover:text-text-primary",
            ].join(" ")
          : [
              "rounded border border-border-subtle px-2 py-1",
              paused
                ? "bg-accent text-white"
                : "bg-card text-text-secondary hover:text-text-primary",
            ].join(" "),
      ].join(" ")}
    >
      {paused ? <Play size={12} strokeWidth={2.5} /> : <Pause size={12} strokeWidth={2.5} />}
    </button>
  );
}
